import { mediaUrl } from "./mediaUrl";

export const projectText = (project, field, lang) =>
  project?.[`${field}_${lang}`] || project?.[`${field}_en`] || project?.[`${field}_ar`] || "";

// A public case study remains available when the optional project API is offline.
export const sadeedCaseStudy = {
  slug: "sadeed",
  title_ar: "سديد",
  title_en: "Sadeed",
  title_fr: "Sadeed",
  type_ar: "منصة تجارة ونقاط بيع",
  type_en: "Commerce and POS platform",
  type_fr: "Plateforme de commerce et de caisse",
  statement_ar: "تجربة عربية تساعد التاجر على عرض منتجاته وإدارة البيع والمخزون من مكان واحد.",
  statement_en: "An Arabic-first experience for showcasing products and managing sales and inventory in one place.",
  statement_fr: "Une expérience pensée en arabe pour présenter les produits et gérer les ventes et le stock au même endroit.",
  problem_ar: "يحتاج التاجر إلى طريقة واضحة لعرض منتجاته ومتابعة الطلبات والمخزون دون التنقل بين أدوات متفرقة.",
  problem_en: "Merchants need a clear way to present products and follow orders and inventory without switching between separate tools.",
  problem_fr: "Les commerçants ont besoin d'un moyen clair de présenter leurs produits et de suivre les commandes et le stock sans multiplier les outils.",
  solution_ar: "صممت وبنيت سديد كتجربة تجمع واجهة المتجر وإدارة المنتجات والبيع، مع أداة لتجهيز صور المنتجات بالذكاء الاصطناعي. وأنجزت صفحة تعريف عربية تشرح المنتج للتجار.",
  solution_en: "I designed and built Sadeed around the storefront, product management, and sales, with an AI tool for preparing product images. I also built an Arabic landing page explaining the product to merchants.",
  solution_fr: "J'ai conçu et développé Sadeed autour de la vitrine, de la gestion des produits et des ventes, avec un outil IA pour préparer les images. J'ai aussi réalisé une page de présentation en arabe.",
  outcome_ar: "صفحة المشروع منشورة، والمنتج متاح للتجربة المبكرة عبر التواصل مع فريق سديد. لا أنسب إليه نتائج تجارية لم تُقَس بعد.",
  outcome_en: "The product page is live, and early access is available through the Sadeed team. Commercial results have not yet been measured.",
  outcome_fr: "La page du produit est en ligne et l'accès anticipé passe par l'équipe Sadeed. Les résultats commerciaux ne sont pas encore mesurés.",
  external_url: "https://sadeedpos.tech/",
  cover_url: mediaUrl("/project-assets/sadeed/cover.png"),
  gallery: [],
};
